/**
 * Load More button component
 * 
 * @module load-more
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'load-more';

if (!customElements.get(customElements.component)) {

    class loadMore extends HTMLElement {

        /**
         * Load More web component.
         * 
         * @constructor
         */
        constructor() {
            super();

            this.productsContainer = document.querySelector('[data-load-more-grid]');
            this.loadMoreBtn = this.querySelector('[data-load-more-btn]');
            this.page = 1; // Initialize page to 1

            const urlParams = new URLSearchParams(window.location.search);


            // custom logic start to disable infinite scroll when sort by discount is applied
            if (urlParams.get('sort_by') === 'discount-descending' || urlParams.get('sort_by') === 'discount-ascending') {
                const productContainer = document.querySelector('[data-load-more-grid]');
                // this.restorePage = parseInt(urlParams.get('loadMore') || 1);
                productContainer.classList.add('load-more-grid');
                if (urlParams.get('sort_by') === 'discount-descending') {
                    this.sortProductsByDiscount(productContainer, false);
                    document.querySelector("[data-discount-sort-by='discount-descending']").classList.add('active');
                } else if (urlParams.get('sort_by') === 'discount-ascending') {
                    this.sortProductsByDiscount(productContainer, true);
                    document.querySelector("[data-discount-sort-by='discount-ascending']").classList.add('active');
                }
            }

            // custom logic end to to disable infinite scroll when sort by discount is applied


            // if (urlParams.get('sort_by') === 'discount-descending' || urlParams.get('sort_by') === 'discount-ascending') {
            //     const productContainer = document.querySelector('[data-load-more-grid]');
            //     productContainer.classList.add('load-more-grid');

            //     if (urlParams.get('sort_by') === 'discount-descending') {
            //         this.sortProductsByDiscount(productContainer, false);
            //         document.querySelector("[data-discount-sort-by='discount-descending']").classList.add('active');
            //         document.querySelector(".pagination").classList.add('hidden');
            //     } else {
            //         this.sortProductsByDiscount(productContainer, true);
            //         document.querySelector("[data-discount-sort-by='discount-ascending']").classList.add('active');
            //         document.querySelector(".pagination").classList.add('hidden');
            //     }
            // }

            if (this.productsContainer && this.loadMoreBtn) {
                this.count = this.querySelector('[data-count]');
                this.initEvents();
                this.restorePreviousState().then(() => {
                    this.restoreScrollPosition();
                });
            }

            // this.outStockInitEvents();

        }

        outStockInitEvents() {
            document.querySelectorAll("[data-out-of-stock-filter]").forEach(element => {
                element.addEventListener('click', function () {
                    let currentUrl = new URL(window.location.href);
                    currentUrl.searchParams.set('out_of_stock', "true");

                    window.location.search = currentUrl.searchParams.toString();
                });
            });


            const urlParams = new URLSearchParams(window.location.search);

            if (urlParams.get("out_of_stock") === "true") {
                document.querySelector(".collection__footer").classList.add('hidden');
                let totalPages = parseInt(document.querySelector("[data-total-pages]").dataset.totalPages) || 1;
                const productContainer = document.querySelector('[data-load-more-grid]');
                document.querySelector("[data-out-of-stock-filter]").classList.add('active');

                productContainer.classList.add('load-more-grid');

                const filterOutOfStockProducts = (products) => {
                    return products.filter(product => product.dataset.outOfStock === "true");
                };

                const appendProducts = (products) => {
                    productContainer.innerHTML = '';
                    products.forEach(product => productContainer.appendChild(product));

                    const eventQuickView = new CustomEvent('init-quickview');
                    window.dispatchEvent(eventQuickView);

                    const eventQuickAddToCart = new CustomEvent('init-quick-add-to-cart');
                    window.dispatchEvent(eventQuickAddToCart);

                    productContainer.classList.remove('load-more-grid');
                };

                if (totalPages > 1) {
                    this.loadAllProducts(totalPages).then(result => {
                        let products = Array.from(productContainer.querySelectorAll('.product-grid__item'));
                        products = filterOutOfStockProducts(products);
                        appendProducts(products);
                        document.querySelector("[data-collection-filter-product-qty]").innerHTML = document.querySelectorAll('[data-out-of-stock="true"]').length;
                    });
                } else {
                    let products = Array.from(productContainer.querySelectorAll('.product-grid__item'));
                    products = filterOutOfStockProducts(products);
                    appendProducts(products);
                    document.querySelector("[data-collection-filter-product-qty]").innerHTML = document.querySelectorAll('[data-out-of-stock="true"]').length;
                }
            }

        }

        /**
         * Init component.
         * 
         * @returns {undefined}
         */
        initEvents() {
            this.loadMore = this.loadMore.bind(this);

            this.loadMoreBtn.addEventListener('click', event => {
                event.preventDefault();

                this.loadMore().then(result => {
                    const eventQuickView = new CustomEvent('init-quickview');
                    window.dispatchEvent(eventQuickView);

                    const eventQuickAddToCart = new CustomEvent('init-quick-add-to-cart');
                    window.dispatchEvent(eventQuickAddToCart);
                });
            });

            window.addEventListener('beforeunload', () => {
                sessionStorage.setItem('scrollPosition', window.scrollY);
            });
        }

        loadMore() {
            return new Promise((resolve, reject) => {
                this.loadMoreBtn.setAttribute("disabled", "disabled");
                document.body.style.overflow = 'hidden'; // Disable scroll

                this.page++;

                // Capture existing URL parameters (including filters)
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.set('loadMore', this.page);

                const search = window.location.pathname == '/search'
                    ? `?options%5Bprefix%5D=last&page=${this.page}&q=a&type=product`
                    : `?page=${this.page}`


                const url = `${window.location.pathname}${search}`;

                fetch(url).then(response => response.text()).then((responseText) => {
                    const html = responseText;

                    const html_dom = new DOMParser().parseFromString(html, 'text/html');

                    // add new products to the grid
                    const newProducts = html_dom.querySelectorAll('[data-load-more-grid] .product-grid__item');
                    this.productsContainer.append(...newProducts);

                    // update load more button
                    this.count.innerHTML = newProducts.length + parseInt(this.count.innerHTML);

                    if (parseInt(this.count.innerHTML) != parseInt(this.dataset.total)) {
                        this.loadMoreBtn.removeAttribute('disabled');
                    } else {
                        this.loadMoreBtn.remove();
                    }

                    // Update URL with the current page and filters
                    history.replaceState(null, '', `${window.location.pathname}?${urlParams.toString()}`);

                    // re-enable scroll
                    document.body.style.overflow = '';

                    resolve(true);
                }).catch(error => {
                    document.body.style.overflow = '';
                    reject(error);
                });
            });
        }

        sortProductsByDiscount(productContainer, invert) {
            let totalPages = parseInt(document.querySelector("[data-total-pages]").dataset.totalPages) || 1;

            const sortFunction = (a, b) => {
                const aDiscount = parseFloat(a.dataset.discount) || 0;
                const bDiscount = parseFloat(b.dataset.discount) || 0;

                return invert ? aDiscount - bDiscount : bDiscount - aDiscount;
            };

            const sortAndAppendProducts = (products) => {
                products.sort(sortFunction);

                productContainer.innerHTML = '';
                products.forEach(product => productContainer.appendChild(product));

                const eventQuickView = new CustomEvent('init-quickview');
                window.dispatchEvent(eventQuickView);

                const eventQuickAddToCart = new CustomEvent('init-quick-add-to-cart');
                window.dispatchEvent(eventQuickAddToCart);

                productContainer.classList.remove('load-more-grid');
            };

            // custom logic start to disable all products load when sort by discount is applied

            const products = Array.from(productContainer.querySelectorAll('.product-grid__item'));
            sortAndAppendProducts(products);

            return;
            // custom logic end

            if (totalPages > 1) {
                this.loadAllProducts(totalPages).then(result => {
                    const products = Array.from(productContainer.querySelectorAll('.product-grid__item'));
                    sortAndAppendProducts(products);
                });
            } else {
                const products = Array.from(productContainer.querySelectorAll('.product-grid__item'));
                sortAndAppendProducts(products);
            }
        }

        loadAllProducts(totalPages) {
            return new Promise((resolve, reject) => {
                this.loadMoreBtn.setAttribute("disabled", "disabled");

                let loadPromises = [];
                for (let i = 1; i < totalPages; i++) {
                    this.page = i;
                    loadPromises.push(this.loadMore());
                }

                Promise.all(loadPromises).then(() => resolve(true)).catch(reject);
            });
        }

        async restorePreviousState() {
            //  verify if url contains page parameter
            const urlParams = new URLSearchParams(window.location.search);
            if (!urlParams.get('loadMore'))
                return;

            this.productsContainer.classList.add('load-more-grid');

            const totalPages = this.restorePage;
            for (let i = 1; i < totalPages; i++) {
                await this.loadMore().then(result => {
                    const eventQuickView = new CustomEvent('init-quickview');
                    window.dispatchEvent(eventQuickView);

                    const eventQuickAddToCart = new CustomEvent('init-quick-add-to-cart');
                    window.dispatchEvent(eventQuickAddToCart);
                });
            }
        }

        restoreScrollPosition() {
            //  verify if url contains page parameter
            const urlParams = new URLSearchParams(window.location.search);
            if (!urlParams.get('loadMore'))
                return;

            this.productsContainer.classList.remove('load-more-grid');
            const scrollPosition = sessionStorage.getItem('scrollPosition');

            if (scrollPosition) {
                setTimeout(() => {
                    window.scrollTo(0, parseInt(scrollPosition));
                }, 500);
            }
        }
    }

    customElements.define(customElements.component, loadMore);
}
